import React from 'react';
import { Form, Button } from 'antd';
import { FormItemWrap } from '@unicus/react-ui-kit';
import { PlusOutlined } from '@ant-design/icons';
import lodash from 'lodash';

const FormListContext = React.createContext({ form: null });

const FormListItemWrap = ({ children, name, noStyle, ...rest }) => {
  const { field } = React.useContext(FormListContext);

  if (!field) {
    throw new Error('Missing FormListWrap in its parent.');
  }

  const getName = () => {
    if (typeof name === 'string') {
      return [name];
    }

    return name;
  };

  return (
    <FormItemWrap
      {...field}
      name={[field.name, ...getName()]}
      fieldKey={[field.fieldKey, ...getName()]}
      noStyle={noStyle}
      {...rest}
    >
      {children}
    </FormItemWrap>
  );
};

const FormListWrap = ({
  name,
  onBeforeCreateItem,
  onRemove = () => true,
  addText = 'Adicionar',
  hideAddButton = false,
  children,
  rules
}) => {
  const handleRemove = (remove, fieldIndex, value) => {
    if (onRemove(value)) {
      remove(fieldIndex);
    }
  };

  const handleAdd = (add) => {
    let value = {};

    if (onBeforeCreateItem) {
      value = onBeforeCreateItem(value);
    }

    add(value);
  };

  return (
    <>
      <Form.List name={name} rules={rules}>
        {(fields, { add, remove }, { errors }) => (
          <>
            {fields.map((field, index) => (
              <FormListContext.Provider value={{ field }} key={field.name}>
                <Form.Item
                  noStyle
                  shouldUpdate={(prevValues, curValues) => {
                    return lodash.isEqual(prevValues, curValues);
                  }}
                >
                  {({ getFieldValue }) => {
                    const value = getFieldValue([name, field.name]);
                    return children({
                      onCreate: () => handleAdd(add),
                      onRemove: () => handleRemove(remove, index, value),
                      field,
                      fields,
                      value,
                      index
                    });
                  }}
                </Form.Item>
              </FormListContext.Provider>
            ))}
            {!hideAddButton && (
              <Button
                className="gx-p-0"
                type="link"
                icon={<PlusOutlined />}
                onClick={() => handleAdd(add)}
              >
                {addText}
              </Button>
            )}
            <Form.ErrorList errors={errors} />
          </>
        )}
      </Form.List>
    </>
  );
};

export { FormListWrap, FormListItemWrap, FormListContext };
